import { getEnv } from '../utilty';

class UnleashService {
  static CONFIG = {
    url: getEnv('REACT_APP_UNLEASH_URL'),
    clientKey: getEnv('REACT_APP_UNLEASH_CLIENT_KEY'),
    refreshInterval: getEnv('REACT_APP_UNLEASH_REFRESH_INTERVAL'),
    appName: getEnv('REACT_APP_UNLEASH_APP_NAME'),
    environment: getEnv('REACT_APP_UNLEASH_ENVIRONMENT'),
  };

  static FLAGS = {
    TEST_RELEASE: 'TestRelease',
    AUTHORIZATION: 'authorization',
    RESPONSE_NEEDED_WARNING: 'responseNeededWarning',
    ANNOUNCEMENT_AUDIT: 'announcementAudit',
    INSIGHT_TAB_IN_LEARNER_PROFILE: 'insightsTabInLearnerProfile',
    NEW_CONVERSATION_REFACTORING: 'newConversationRefactoring',
    SISENSE_DASHBOARD_SUBTAB: 'sisenseDashboardSubtab',
    VOICE_CALL: 'manageVoiceCallFeature',
    CREATE_SUPER_ADMIN: 'createSuperAdmin',
    ENFORCE_DOCID_CHARACTER_RULES: 'enforceDocIdCharacterRules',
    LOCATION_PERSIST_FLOW: 'locationPersistenceFlow',
    V2_OMNI_SEARCH: 'v2OmniSearch',
    MANAGE_PROGRAMS: 'managePrograms',
    STAFF_PROFILE_UI_PAGE: 'staffProfileUiToPage',
    LEARNER_MILESTONE_MAPPER: 'learnerMilestoneMapper',
    SHOW_SNACK_BAR_ON_MESSAGE_SENT: 'showSnackBarOnMessageSent',
    USERS_MODULE_BTN_ALIGNMENT_FIX: 'usersModuleBtnAlignmentFix',
    COMMUNICATION_TAB_FOR_ADMIN_ONLY: 'communicationTabForAdminsOnly',
    SHOW_CERTIFICATE_IN_ADMIN_PORTAL: 'showCertificatesInAdminPortal',
    FORM_ACTION_FOR_SUPER_ADMIN_ONLY: 'formActionForSuperAdminOnly',
    VIEW_PROFILE_FROM_MESSAGES: 'viewProfileFromMessages',
    HIDE_HOUSING_UNITS_VOICE_CALL_MODULE: 'HideHousingUnitsVoiceCallModule',
    RESUME_BUILDER_TOGGLE: 'resumeBuilderToggle',
    CAREER_COMPASS_ACCESS_TOGGLE: 'careerCompassAccessToggle',
    LEARNER_TOGGLE_RESUME_BUILDER: 'learnerToggleResumeBuilder',
    RESUME_MODULE: 'resumeModule',
    EDIT_RESUME: 'editLearnerResume',
    CLEAR_DEVICE_PAIRING_TOGGLE: 'clearDevicePairingOnLocationChangeToggle',
    HU_DATA_CACHE_FIX: 'locationPickerHuDataFix',
    ARCHIVE_UNARCHIVE_TOGGLE: 'archiveUnarchiveContactsToggle',
    RESUME_DOWNLOAD_DOCX_BTN: 'resumeDownloadDocxButton',
    RESTORE_FA_ACCESS: 'restoreFAToSeeActions',
    RESTRUCTURE_COMMUNICATION_TAB: 'restructureCommunicationTab',
    BYPASS_HOME_PAGE: 'byPassHomePage',
    CALL_HISTORY_LIVE_CALLS_DESIGN_V2: 'callHistoryLiveCallsDesignV2',
    RECLASSIFY_FEATURED_CONTENT: 'reclassifyFeaturedContent',
    RECLASSIFY_MILESTONE_MAPPER: 'reclassifyMilestoneMapper',
    TEACHER_LEARNER_SETTING: 'teacherLearnerSetting',
    FNF_FOR_ADMIN_ONLY: 'fnfForAdminsOnly',
    VOICE_GROUP_SCHEDULE: 'voiceGroupSchedule',
    RELAX_SECURITY_TOGGLE: 'relaxSecurityToggle',
    COMPLETION_REPORT: 'completionReport',
    OPTIMIZE_USER_LISTING_ENDPOINT: 'optimizeUserListingEndpoint',
    DISABLE_DOUBLE_CLICK: 'disableDoubleClick',
    SENDER_ID_OVER_SENDER_NAME: 'useSenderIdOverSenderName_CC-4255',
    OPTIMIZE_SOCKET: 'optimizedSocket',
    KEYWORD_MATCH_CONFIG: 'keywordMatchConfig',
    COMMUNICATION_BREAK_FIX: 'communicationBreakFix',
    USE_OKTA_AUTH0: 'useAuth0',
    MANAGE_RELATIONSHIP_LIST_BY_USERNAME: 'manageRelationshipListByUsername',
    V2_RELATIONSHIP: 'v2Relationship',
    UPDATE_AVAILABILITY_TYPE: 'updateAvailabilityType',
    COMMUNICATION_SECURITY_SETTINGS: 'communicationSecuritySettings',
    MARK_READ: 'markRead',
    ADS_MANAGEMENT: 'adsManagement',
    PERSONALIZED_AVATAR: 'personalizedAvatar',
    LEARNER_PROFILE_INSIGHTS_V2: 'learnerProfileInsightsV2',
    SUPER_ADMIN_VOICE_CONTROLS: 'superAdminVoiceControls',
    ANNOUCEMENT_TAB_PROFILE: 'announcementTabInLearnerProfile',
    VIDEO_CALLS: 'videoCalls',
    ANNOUNCEMENT_DEFAULT_RANGE_LIMIT_IN_YEARS: 'announcementDefaultRangeLimitInYears',
    PERSIST_LAST_VISITED_PATH: 'persistLastVisitedPath',
    MERGE_PDF_CERTIFICATES_INTO_SINGLE_PDF: 'mergePdfCertificatesIntoSinglePDF',
    LEARNER_CERTIFICATES_TAB: 'learnerCertificatesTab',
    VOICE_CALL_INSIGHTS: 'voiceCallInsights',
    SHOW_AWARDS_IN_TRANSCRIPT: 'showAwardsInTranscriptForAP',
    SHOW_AWARDS_IN_TRANSCRIPT_ALL_EXCEPT_EEd: 'showAwardsInTranscriptAllExceptEEd',
    SHOW_STUDY_TIME_IN_TRANSCRIPT: 'showStudyTimeInTranscriptForAP',
    V2_CALL_HISTORY: 'v2CallHistory',
    ENABLE_FEEDS:'enableFeeds',
    DISABLE_V1_MESSAGING:'disableV1Messaging',
    LOCATION_MANAGEMENT_V2: 'locationManagementV2',
    SHOW_MANAGE_PROGRAMS_LISTING_NEW_UI: 'showManageProgramListingNewUI',
    SHOW_FACILITY_DATA_WITH_HOUSING_UNIT_IN_PROGRESS_AND_OVERVIEW: 'showFacilityDataWithHousingUnitInProgressAndOverview',
    FIX_FACILITY_TIME_ON_TASK_TOTALS: 'fixFacilityTimeOnTaskTotals',
    INCLUSIVE_TOT_DATE_RANGE_FILTERS: 'inclusiveTotDateRangeFilters',
    SHOW_BEST_DROPDOWN_IN_SUPER_ADMIN_TOOL: 'showBESTDropdownInSuperAdminTool',
    SHOW_LEARNING_PLAN_IN_ADMIN: 'showLearningPlanInAdmin',
    V2_STAFF_ROLE_LOCATION: 'v2StaffRoleLocation',
    CREATE_STAFF_V2: 'createStaffV2',
    PLA_HISTORY_EXPERIMENTAL: 'plaHistoryExperimental',
    AUDIT_FEED_HISTORY: 'auditFeedHistory',
    FEED_ATTACHMENTS_UPLOAD: 'feedAttachmentsUpload',
    CANVAS_QUEUE_TAB: 'canvasQueueTab',
    COURSE_REVIEW: 'canvasQueueTab',
    FACILITY_LMS_CUTOVER: 'facilityLmsCutover',
    ENABLE_CANVAS_LMS_IN_MANAGE_PROGRAMS: 'enableCanvasLmsInManagePrograms',
    ENABLE_CANVAS_ADMIN_LAUNCH: 'enableCanvasAdminLaunch',
    MANUAL_PROGRAM_CERT_GENERATION: 'enableManualProgramCertGeneration'
  };
}

export default UnleashService;
